import { Injectable } from '@angular/core';

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Environement} from '../../../environement/environement';
import {removeAccents} from '../../partage/prototype/sansAccents';


@Injectable()
export class ListeParutionService {
  private listeParutionUrl = Environement.BASE_API_URL + '/api/liste_parutions';
  private parutionUrl =  Environement.BASE_API_URL + '/api/parutions';
  private listeParutionAssoUrl = Environement.BASE_API_URL + '/api/liste_parution_parutions';
  constructor(private http: HttpClient) { }



  addListeParution(listeParution, clientId) {
    let client = null;
    if (clientId != 0) {
      client = Environement.BASE_API_URL + '/api/clients/' + clientId;
    }
    const DateCre = listeParution.creation.getFullYear() + '-' + (listeParution.creation.getMonth() + 1).toString() + '-' + listeParution.creation.getDate() + ' ' + listeParution.creation.getHours() + ':' + listeParution.creation.getMinutes() + ':00' ;
    const headers = this.initOptionHeader();
    return this.http.post(this.listeParutionUrl, {'nom': listeParution.nom, 'client': client,
        'commentaires': listeParution.commentaires, 'creation' : DateCre,
        'auteur': Environement.BASE_API_URL + '/api/auth_users/' + listeParution.auteur.id},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  importerListeParutionIntranet(listeId, ancienId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/importation/copie/liste/parution/' + listeId + '/' + ancienId,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  addAncienIdListeParution(ancienIdListe, listeId) {
    const headers = this.initOptionHeader();
    return this.http.put(this.listeParutionUrl + '/' +  listeId, {'ancienId': ancienIdListe},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }


  getListesParutionsParDefaut(page) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '?_page=' + page + '&order[nom]=asc', {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }


  getAllListesParutionsPar() {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '?order[nom]=asc&pagination=false', {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListesParutionsRecherche(recherche: Array<any>, page) {
    const content = recherche[0];
    let type = recherche[1];
    const headers = this.initOptionHeader();
    type = removeAccents(type.toLowerCase());
    if (type === 'tous') {
      return this.http.get(this.listeParutionUrl + '?several_all=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'nom') {
      return this.http.get(this.listeParutionUrl + '?liste_parution_nom=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'client') {
      return this.http.get(this.listeParutionUrl + '?liste_parution_client=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'commentaire') {
      return this.http.get(this.listeParutionUrl + '?liste_parution_comment=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
    if (type === 'auteur') {
      return this.http.get(this.listeParutionUrl + '?liste_parution_auteur=' + content + '&_page=' + page + '&order[nom]=asc',
        {headers} ).toPromise()
        .then(response => response)
        .catch(this.errorHandler);
    }
  }

  getListesParutionRechercheIntranet(recherche, type) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/recherche/intranet/' + recherche + '/' + type , {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getListeParutionDetails(id): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/' + id , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAllParutionsListe(listeId, page) {
    const headers = this.initOptionHeader();
    return this.http.get(this.parutionUrl + '?listeParutionParutions.listeParution.id=' + listeId + '&_page=' + page + '&order[date]=desc', {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getParutionsListeAssociees(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.parutionUrl + '?listeParutionParutions.listeParution.id=' + listeId + '&pagination=false&order[date]=desc', {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAncienIdAuteur(listeParutionId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/auteur/intranet/' + listeParutionId , {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  modifierListeParution(listeParution, clientId) {
    let client = null;
    listeParution.modification = new Date();
    const DateModif = listeParution.modification.getFullYear() + '-' + (listeParution.modification.getMonth() + 1).toString() + '-' + listeParution.modification.getDate() + ' ' + listeParution.modification.getHours() + ':' + listeParution.modification.getMinutes() + ':00' ;
    if (clientId != 0) {
      client = Environement.BASE_API_URL + '/api/clients/' + clientId;
    }
    const headers = this.initOptionHeader();
    return this.http.put(this.listeParutionUrl + '/' +  listeParution.id, {'nom': listeParution.nom, 'client': client,
        'commentaires': listeParution.commentaires, 'modification' : DateModif},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  supprimerAssoListeParution(assoId) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeParutionAssoUrl + '/' +  assoId,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getAllAssosListeParution(listeId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionAssoUrl + '?pagination=false&listeParution.id=' + listeId , {headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  supprimerListeParution(id) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeParutionUrl + '/' +  id,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  supprimerImportListeParutionIntranet(ancienIdListe) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/importation/supprimer/copie/liste/parution/' + ancienIdListe ,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }


  addListeParutionParution(parutionId, listeId) {
    const headers = this.initOptionHeader();
    return this.http.post(this.listeParutionAssoUrl, {
        'listeParution': this.listeParutionUrl + '/' + listeId,
        'parution': this.parutionUrl + '/' + parutionId},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  addListeParutionCopie(listeParution, clientId) {
    let client = null;
    if (clientId != 0) {
      client = Environement.BASE_API_URL + '/api/clients/' + clientId;
    }
    let nom = '';
    nom = 'Copie de ' + listeParution.nom;
    const headers = this.initOptionHeader();
    return this.http.post(this.listeParutionUrl, {'nom': nom, 'client': client,
        'commentaires': listeParution.commentaires, 'creation' : listeParution.creation, 'modification' : listeParution.modification,
        'auteur': Environement.BASE_API_URL + '/api/auth_users/' + listeParution.auteur.id},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  exporterListeParution(listeParutionId, id, titre, date, doc, resume, theme, qualification, format, typeRetombee, suitecp, campagne,
                        typeAnnonce, pressroom, photo, illustration, logo, urlClient, agenda, graphique, nomination, tableau, courrier,
                        commentaire, auteur, support, supportid, client, clientid, auteurs, auteursid, suiteSuivi, suiteSuiviid,
                        diffusion) {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/statistique/exportation/liste/parution/' + listeParutionId + '/' + id + '/' + titre
      + '/' + date + '/' + doc + '/' + resume + '/' + theme + '/' + qualification + '/' + format + '/' + typeRetombee + '/' + suitecp
      + '/' + campagne + '/' + typeAnnonce + '/' + pressroom + '/' + photo + '/' + illustration + '/' + logo + '/' + urlClient + '/' +
      agenda + '/' + graphique + '/' + nomination + '/' + tableau + '/' + courrier + '/' + commentaire + '/' + auteur + '/' + support +
      '/' + supportid + '/' + client + '/' + clientid + '/' + auteurs + '/' + auteursid + '/' + suiteSuivi + '/' + suiteSuiviid
      + '/' + diffusion,
      {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getListeParutionIntranet(id) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/recherche/fiche/intranet/' + id , {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  addParutionListe(listeId, parutionId) {
    const headers = this.initOptionHeader();
    return this.http.post(this.listeParutionAssoUrl, {
        'listeParution': this.listeParutionUrl + '/' + listeId,
        'parution': this.parutionUrl + '/' + parutionId},
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  getListeParutionByAncienId(listeAncienId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(Environement.BASE_API_URL + '/api/liste_parutions?ancienId=' + listeAncienId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getAssoParutionListe(listeId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionAssoUrl + '?pagination=false&listeParution.id=' + listeId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }

  getOneAssoParutionListe(listeId, parutionId): Promise<any> {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionAssoUrl + '?listeParution.id=' + listeId + '&parution.id=' + parutionId, {headers: headers}).toPromise()
      .then( response => response)
      .catch(this.errorHandler);
  }
  deleteParutionAssoIntranet( assoId) {
    const headers = this.initOptionHeader();
    return this.http.get(this.listeParutionUrl + '/delete/asso/intranet/' + assoId,
      {headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  deleteAssoParutionListe(assoParutionListeId) {
    const headers = this.initOptionHeader();
    return this.http.delete(this.listeParutionAssoUrl + '/' + assoParutionListeId,{headers: headers} ).toPromise()
      .then(response => response)
      .catch(this.errorHandler);
  }

  private errorHandler(err: any): Promise<any> {
    return Promise.reject(err.message || err );
  }

  private initOptionHeader() {
    const token: any = localStorage.getItem('auth-tokens');
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers = headers.set('X-Auth-Token', token);
    return headers; }
}
